// npm パッケージを `window.xxx` に shim するだけの薄いモジュール。
//
// 重要な順序問題:
//   ES module の `import` 文はすべて hoisted されて他のコードより先に走る。
//   このため main.js の body で `window.firebase = firebase` を代入しても、
//   `import './firebase/config.js'` の IIFE が「より早く」 走って `firebase is not defined` で失敗する。
//
// この shim を main.js が最初に side-effect import することで、
// 「window 代入も import の一部」 として hoist の連鎖の先頭に位置する。
// _libShim.js の static import が解決された直後にこのモジュール body が実行され、
// その時点で window.xxx が populate される。 以降に hoist される
// 旧 IIFE (utils/stores/firebase) は window.xxx を安全に参照できる。
import * as Vue from 'vue'
import * as VueRouter from 'vue-router'
import _ from 'lodash'
import moment from 'moment'
import 'moment/locale/ja'
import axios from 'axios'
import marked from 'marked'
import DOMPurify from 'dompurify'
import CryptoJS from 'crypto-js'
import noUiSlider from 'nouislider'
import SignaturePad from 'signature_pad'
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import 'nouislider/dist/nouislider.css'

// CommonMark では block-level HTML (<div>等) 内のMarkdownは処理されない。
// しかし Q4CL の問診票定義には <div class="note-block">**bold**</div> のような
// HTML+Markdown混在記述があるため、html token の renderer を拡張し、
// ブロック要素内のMarkdownを再帰的に parse する。
marked.use({
  extensions: [{
    name: 'html',
    renderer(token) {
      return token.text.replace(
        /<(div|section|article|blockquote|details|fieldset|figure|figcaption|summary|header|footer|main|nav|aside)\b([^>]*>)([\s\S]*?)<\/\1>/gi,
        (_, tag, attrsEnd, content) => `<${tag}${attrsEnd}${marked.parse(content)}</${tag}>`
      );
    }
  }]
});

window.Vue = Vue
window.VueRouter = VueRouter
window._ = _
window.moment = moment
window.axios = axios
window.marked = marked
window.DOMPurify = DOMPurify
window.CryptoJS = CryptoJS
window.noUiSlider = noUiSlider
window.SignaturePad = SignaturePad
window.firebase = firebase

// moment 日本語ロケール (旧 app.js 踏襲)
moment.locale('ja')
